<template>
  <div class="c-editDialog-list">
    <el-row class="c-editDialog-list-row">
      <draggable v-model='dataLists' @start='handleStart' @end='handleEnd'>
        <transition-group name="list" tag="p">
          <el-col
            :span="12"
            class="c-editDialog-list-row-col"
            v-for="(i,index) in dataLists"
            :key="i.id"
          >
            <div
              class="c-editDialog-list-row-col-label textEllipsis"
              :style="{ borderLeft:i.borderLeft,borderBottom:i.borderBottom }"
              :title="i.columnName"
               v-if="listType==1?(i.fillRule===fillRule || i.fillRule===0):true"
            >
              {{ i.columnName }}
            </div>
            <div
             v-if="listType==1?(i.fillRule===fillRule || i.fillRule===0):true"
              class="c-editDialog-list-row-col-value"
              :style="{ borderBottom:i.borderBottom }"
            >
              <div class="c-editDialog-list-row-col-value-discribe">
                字段格式：{{getType(i.customType)}}
              </div>
              <div class="c-editDialog-list-row-col-value-operation">
                 <span
                    v-for="item in btnList"
                    :style=" { color: item.color } "
                    @click.stop="handleClick(item,i)"
                    class="c-editDialog-list-row-col-value-operation-items"
                    :key="item.id"
                  >
                    {{ item.name }}
                 </span>
                 <img
                  src="/static/icon/drag_mark.png"
                  alt=""
                  v-if="listType==1"
                  class="c-editDialog-list-row-col-value-operation-items">
              </div>
            </div>
          </el-col>
        </transition-group>
      </draggable>
    </el-row>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    components:{
      draggable
    },
    props:{
      dataList:[Array],
      listType:[Number],
      fillRule:[Number]
    },
    data() {
      return {
        btnBaseList:[
          {
            name:"编辑",
            id:1,
            color:"#268AFF",
          },
          {
            name:"禁用",
            id:2,
            color:"#FF6010",
          },
          {
            name:"取消禁用",
            id:3,
            color:"#FF6010",
          },
          {
            name:"删除",
            id:4,
            color:"#FF3049",
          }
        ]
      }
    },
    computed:{
      dataLists: {
        get() {
          let dataList = this.$lodash.cloneDeep(this.dataList)
          let arrList = [];  // 参与计算数组
          if(this.listType==1) {
            dataList.forEach(i=>{
              i.borderBottom = "1px solid #ccc"
              if(i.fillRule===this.fillRule || i.fillRule===0) {
                arrList.push(i)
              }
            })
          }else {
            arrList = dataList;
          }
          if(arrList.length) {
            let num = arrList.length;
            arrList.forEach((i,index)=>{
              if(index%2===1) {
                i.borderLeft = "1px solid #ccc"
              }else {
                i.borderLeft = "none"
              }
              if((num%2===0)&&(index === (num-1) || index === (num-2))) {  // 偶数  且是最后两项  取消border
                  i.borderBottom = "none"
              }
              if((num%2===1)&&(index === (num-1))) {  // 奇数  并且是最后一项  取消border
                 i.borderBottom = "none"
              }
            })
          }
          for(var i = 0;i<arrList.length;i++) {
            for(var j = 0;j<dataList.length;j++) {
              if(arrList[i].id === dataList[i].id) {
                dataList[i].borderLeft = arrList[i].borderLeft
                dataList[i].borderBottom = arrList[i].borderBottom
              }
            }
          }
          return dataList;
        },
        set(val) {
          this.$emit('getList',val)
        }
      },
      btnList() {
         let arr = this.btnBaseList;
         if(this.listType==1) arr.splice(2,1);
         else arr.splice(1,1);
         return arr;
       }
    },
    methods:{
      // 动态计算border
      getBottomBorder(index) {
         let borderStyle = "",num = this.dataList.length;
         if((num%2===0)&&(index === (num-1) || index === (num-2))) {  // 偶数  且是最后两项  取消border
             borderStyle = "none"
         }else if(index === (num-1)) {  // 奇数  并且是最后一项  取消border
            borderStyle = "none"
         }
         return borderStyle;
      },
      getType(type) {
         let text = ""
         type = Number(type);
         switch(type) {
           case 1:
            text = "文本框";
            break;
          case 2:
            text = "日期";
            break;
          case 3:
            text = "数值";
            break;
          case 4:
            text = "选项";
            break;
          case 5:
            text = "图片";
            break;
          case 6:
            text = "按钮";
            break;
         }
         return text;
      },
     // 拖动开始
     handleStart(e){
     	e.item.style.background='#eee';
     	e.item.style.transform='translateX(0px)';
     	e.item.style.borderRadius ='5px';
     	e.item.style.opacity ='.5';
     },
     // 拖动结束
     handleEnd(e) {
     	e.item.style.background='';
     	e.item.style.transform='translateX(0px)';
     	e.item.style.borderRadius ='0px';
     	e.item.style.opacity ='1';
      this.$emit('getList',this.selectList)
     },
      handleClick(item,row) {
        this.$emit('operatClick',item,row);
      },
    }
  }
</script>

<style lang="less" scoped>
  .c-editDialog-list {
    border: 1px solid #666666;
    &-row {
      &-col {
        display: flex;
        &-label {
          width: 100px;
          padding: 10px;
          box-sizing: border-box;
          text-align: left;
          border-right: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
        }
        &-value {
          flex: 1;
          box-sizing: border-box;
          padding: 10px;
          border-bottom: 1px solid #ccc;
          display: flex;
          justify-content: space-between;
          &-discribe {
            color: #C2C2C7;
          }
          &-operation {
            display: flex;
            align-items: center;
            img {
              width: 14px;
              height: 14px;
            }
            &-items {
              font-size: 12px;
              cursor: pointer;
              margin-right: 10px;
              &:last-child { margin-right: 0; }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/edit-list.vue